import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import WorkflowManagement from './WorkflowManagementPage';
import EnterpriseDashboard from './EnterpriseDashboard';
import { CheckCircle, LayoutDashboard } from 'lucide-react';

function UnifiedWorkflowPage() {
  const [activeTab, setActiveTab] = useState('workflows');

  return (
    <div className="w-full space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Workflows</h1>
        <p className="text-sm text-gray-500 mt-0.5">Manage approval workflows and enterprise analytics</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="workflows" className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>Workflow Management</span>
          </TabsTrigger>
          <TabsTrigger value="enterprise" className="flex items-center gap-2">
            <LayoutDashboard className="w-4 h-4" />
            <span>Enterprise Analytics</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="workflows" className="mt-6">
          <WorkflowManagement />
        </TabsContent>

        <TabsContent value="enterprise" className="mt-6">
          <EnterpriseDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default UnifiedWorkflowPage;
